import { Outlet } from 'react-router-dom';

import { ToastViewport } from '../components/ToastViewport.js';
import { useRealtime } from '../hooks/useRealtime.js';
import { Navbar } from './Navbar.js';

export function AppLayout() {
  useRealtime();

  return (
    <div className="app-shell">
      <Navbar />
      <main className="app-main">
        <Outlet />
      </main>
      <ToastViewport />
    </div>
  );
}
